import "./style/main.scss";
import App from './components/App.svelte';
const app = new App({
    target: document.querySelector('#weather-widget'),
    props: {
        name: 'weather-widget'
    }
});
export default app;
